import React from "react";
import MetricCard from "./MetricCard";

/**
 * Renders the role-specific metric list (see roleConfig.js) as a responsive
 * grid - 1 column on narrow phones, 2 on small screens, auto-fitting up to
 * 4+ on desktop, via CSS Grid `auto-fit` (no JS breakpoint logic needed).
 */
export default function DashboardSummary({ metrics }) {
  if (!metrics || metrics.length === 0) return null;

  return (
    <div className="metric-grid">
      {metrics.map(metric => (
        <MetricCard key={metric.key} {...metric} />
      ))}
    </div>
  );
}
